import React, { ReactNode, useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { POST } from "api/index";
import Tour from "../components/Tour"

export default function Authenticator({ children }: { children: ReactNode }) {
    const { pathname } = useLocation();
    const navigate = useNavigate()
    const [showChild, setShowChild] = useState(false);
    const [showTour, setShowTour] = useState(false);
    const [tourActive, setTourActive] = useState(false);

    useEffect(() => {

        const checkAuthAndTour = async () => {
            const token = localStorage.getItem('currentUserToken');

            if (token) {
                if (pathname === `/auth`) {
                    navigate('/myskills');
                    return;
                }

                //Check first login
                const body = new URLSearchParams();
                body.append("userToken", token);
                const resp = await POST("getUserFirstLogin", body);

                if (resp?.result?.firstLogin === true &&!tourActive ) {
                    setShowTour(true);
                    setTourActive(true);
                }
                setShowChild(true);
            } else {
                localStorage.removeItem('currentUserToken');
                localStorage.removeItem('currentUserName');

                if (pathname !== `/auth`)
                    navigate('/auth');
                else
                    setShowChild(true);
            }
        };

        checkAuthAndTour();
    }, [navigate, pathname]);


    const handleTourFinish = async () => {
        const token = localStorage.getItem("currentUserToken");
        if (!token) return;

        const body = new URLSearchParams();
        body.append("userToken", token);
        await POST("setUserFirstLoginFalse", body);
        setShowTour(false);
        setTourActive(false); 
    };


    return (
        <>
            {showTour && <Tour onFinish={handleTourFinish} />}
            {showChild && children}
        </>
    )
}